/**
 * Classe responsável por aceitar todas as sugestões selecionadas.
 *
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 * DATE: 30/07/2013
 *
 */


Greenmile.ServiceTimeUpdates = Greenmile.ServiceTimeUpdates || {};

Greenmile.ServiceTimeUpdates.AcceptAll = (function () {

    AcceptAll.prototype = new Monet.Grid.ActionsModules.ButtonEventCheckBox();

    function AcceptAll () {

        this.setValueBtn = function () {
            const value = Monet.I18n.getResourcesByKey("Greenmile.ServiceTimeUpdates.btnAcceptAll");
            this.valueBtn = value;
        };

        this.actionAfterClickButton = function () {

            var error  = null;

            try {

                const confirmAcceptAll = () => {
                    App.Objects.ServiceTimeUpdates.acceptAll();
                };

                new Greenmile.Components.AlertModal("Greenmile.ServiceTimeUpdates.confirmAcceptAll",
                    null,
                    confirmAcceptAll)
                .show();

            } catch (e) {

                error = new Monet.Exception.ReturnError(this,
                    "Error on action after click button on accept all.", e);
                error.console();

            }

        };

        this.initialize = function (entity) {

            this.setEntity(entity);
            this.setSelector("#ServiceTimeUpdates .gridHeaderContainer .rightContainer");
            this.setScreenName("#ServiceTimeUpdates");
            this.setValueBtn();
            this.setId("btnAcceptAll");
            this.setBtnSelector('#ServiceTimeUpdates #btnAcceptAll');
            this.init();
        };

    }

    return AcceptAll;

})();
